import { ItineraryActions } from '~/actions/trip/itinerary'
import { TripProductActions } from '~/actions/trip/product'
import { Itinerary2 } from '~/models/Itinerary'
import { PRODUCT_CATEGORY, PRODUCT_ORDER } from '~/models/Product'

export function useTrip(tripId: string) {
	const trip = useState<Itinerary2 | undefined>(`${tripId}-trip`, () => undefined)
	const hasProducts = useState<boolean | undefined>(`${tripId}-trip-has-products`, () => undefined)
	const hasActivities = useState<boolean | undefined>(
		`${tripId}-trip-has-activities`,
		() => undefined
	)

	const getTrip = async () => {
		trip.value = await ItineraryActions.getItinerary(tripId)
	}

	const getProducts = async () => {
		try {
			const products = await TripProductActions.getProducts(tripId, PRODUCT_ORDER.FEATURED, {
				category: PRODUCT_CATEGORY.TRIP,
			})
			hasProducts.value = Boolean(products.items?.length)
		} catch (error) {
			console.error(error)
			hasProducts.value = false
		}
	}

	const getActivities = async () => {
		try {
			const activities = await TripProductActions.getProducts(tripId, PRODUCT_ORDER.FEATURED, {
				category: PRODUCT_CATEGORY.ACTIVITY,
			})
			hasActivities.value = Boolean(activities.items?.length)
		} catch (error) {
			console.error(error)
			hasProducts.value = false
		}
	}

	const resetTrip = async () => {
		trip.value = undefined
	}

	return {
		trip,
		hasProducts,
		hasActivities,
		getTrip,
		getProducts,
		getActivities,
		resetTrip,
	}
}
